import { Box, IconButton, InputAdornment, TextField } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";

import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

export default function SearchField({
    initialValue = "",
    onDebouncedChange,
    debounceDelay = 600,
    placeholder,
    disableClear,
    externalRef = null,
    resetPage = null
}) {
    const textRef = useRef(null);
    const debounceRef = useRef(null);

    const [value, setValue] = useState(initialValue ?? "");

    const { appLanguage, resourceFinal } = useSelector((state) => state.settings.resource.resources);

    const handleChange = (e) => {
        const newValue = e.target.value;
        setValue(newValue);

        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            if (onDebouncedChange) {
                onDebouncedChange(newValue);
                if (resetPage) resetPage(1);
            }
        }, debounceDelay);
    };

    const handleClear = () => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        externalRef ? externalRef.current.value = "" : textRef.current.value = "";
        setValue("");
        onDebouncedChange?.("");
        if (resetPage) resetPage(1);
    };

    useEffect(() => {
        return () => clearTimeout(debounceRef.current);
    }, []);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <TextField
                inputRef={externalRef ?? textRef}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <SearchIcon color="primary" />
                            </InputAdornment>
                        ),
                        endAdornment: (<>
                            {!disableClear &&
                                < InputAdornment position="end" >
                                    <IconButton
                                        aria-label="clear search"
                                        onClick={handleClear}
                                        edge="end"
                                        size="small"
                                        color="secondary"
                                        disabled={!value}
                                    >
                                        <CloseIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                        </>),
                    },
                }}
                placeholder={placeholder ?? resourceFinal[appLanguage].words.SEARCH}
                variant="standard"
                onChange={handleChange}
                value={value}
            />
        </Box >
    );
}